import { Descendant, Element, Text } from 'slate';
import { ElementTypes, LinkElement, MentionElement } from 'src/types/CustomSlateTypes';
import isList from 'src/components/RichTextEditor/isList';

// Recursively concat all the text from the block
const toString: (node: Partial<Descendant>, isValidatingUrls?: boolean) => string = (
  node,
  isValidatingUrls,
) => {
  if (Text.isText(node)) {
    return node.text;
  }

  const { children, type } = node as Element;
  let text = children?.map((child) => toString(child, isValidatingUrls)).join(isList(type) ? ' ' : '') || '';
  if (type === ElementTypes.link) {
    const { url } = node as LinkElement;
    if (isValidatingUrls) text += ` ${url} `;
  } else if (type === ElementTypes.mention) {
    const { username } = node as MentionElement;
    if (isValidatingUrls) text += ` @${username} `;
    else text += `@${username}`;
  }

  return text;
};

const serializeToPlaintext = (nodes?: Partial<Descendant>[], isValidatingUrls?: boolean) => {
  if (!nodes) return '';
  return nodes.map((n) => toString(n, isValidatingUrls)).join(' ');
};

export default serializeToPlaintext;
